import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faArrowsRotate, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import { useLocation, useNavigate, Link } from "react-router-dom";
import swal from "sweetalert";
// import ModalRapor from './modal/rapor';

export default function KonfigurasiAngketTeacher() {
  document.title = "Konfigurasi Angket";


    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1); 
  
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const [descending] = useState(0);
    const [keyword] = useState("");
    const token = localStorage.getItem("token");
    
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
    const [loading, setLoading] = useState(false);

    const firstLoadDone = useRef(false);

    const storageBranchGroping = localStorage.getItem("ysb_branch_id");
    const storageBranch = localStorage.getItem('ysb_branch_id');
    const storageLevel = localStorage.getItem("level");
    const storageSchoolId = localStorage.getItem('ysb_school_id');
    const storageTeacher = localStorage.getItem('teacherID');
    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

    
    // Table data
    const [getData, setGetData] = useState([]);

    // const [getStatic, setGetStatic] = useState([]);
    const [getStatic, setGetStatic] = useState({
      total_siswa: 0,
      status_self: "0/0",
      status_peer: "0/0",
      belum: 0,
    });

    // Search 
    const [searchKeyword, setSearchKeyword] = useState("");

    // Pagination
    const [tablePage, setTablePage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [selectedTab, setSelectedTab] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");

    // Filter form
    const [form2, setForm2] = useState({
      ysb_semester_id: "",
      ysb_branch_id: "",
      ysb_school_id: "",
      ysb_grade_level_id:"",
      ysb_kelas_id:"",
    });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

    // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

    const getRowId = useCallback(
      (row) => String(row?.id ?? row?.studentId ?? row?.nisn ?? ""),
      []
    );

    const toStatusCode = (v) => {
      const s = String(v ?? "").trim().toLowerCase();
      if (s === "1" || s === "belum") return 1;
      if (s === "2" || s === "proses") return 2;
      if (s === "3" || s === "selesai") return 3;
      return 1;
    };

    const buildStatisticsFromRows = (rows = [], prevStat = {}) => {
      const total = Number(prevStat?.total_siswa ?? rows.length ?? 0);

      const selfDone = rows.filter((r) => toStatusCode(r?.status_self) === 3).length;
      const peerDone = rows.filter((r) => toStatusCode(r?.status_peer) === 3).length;

     
      const belum = rows.filter(
        (r) => toStatusCode(r?.status_self) === 1 || toStatusCode(r?.status_peer) === 1
      ).length;

      return {
        total_siswa: total,
        status_self: `${selfDone}/${total}`,
        status_peer: `${peerDone}/${total}`,
        belum,
      };
    };


  // =========================
  // INIT: Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes] = await Promise.all([
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // )
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        )
      ]);

      if (!isMounted.current) return;

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
        setLoading(false);      
    }
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete =
    isFilterDirty && !!form2.ysb_semester_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id 
  ) return;

  const params = {

          ysb_semester_id: form2?.ysb_semester_id,
          level: storageLevel,
          ysb_branch_id: storageBranch,
          ysb_school_id: storageSchoolId,
          ysb_teacher_id: storageTeacher
  };

  try {
    const response = await APILA.get(
      "/api/konfigurasi-angket-teacher",
      {
        params,
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
      setGetStatic(
            response?.data?.statistics || {
              total_siswa: 0,
              status_self: "0/0",
              status_peer: "0/0",
              belum: 0,
            }
          );
    }
  } catch (error) {
    swal({
      title: "Gagal",
      text: error?.response?.data?.message || "Gagal mengambil data",
      icon: "error",
    });
  }
}, [form2, fetchParams, storageLevel]);



  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id 
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id
  ]);

  // =========================
  // HANDLER perubahan filter
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setGetData([]);
    setSearchKeyword("");
    setHasSearched(false);
    setIsFetching(true);

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );
  
  // const filteredData = useMemo(() => {
  //   const q = (searchKeyword || "").trim().toLowerCase();
      
  //   const base = !q
  //         ? (getData || [])
  //         : (getData || []).filter((item) => {
  //           const name = (item?.nama_siswa || "").toString().toLowerCase();
  //           const nisn = (item?.nisn || "").toString().toLowerCase();
  //           return name.includes(q) || nisn.includes(q);
  //         });
      
  //         return [...base].sort((a, b) =>
  //           nameCollator.compare(
  //             (a?.nama_siswa || "").toString().trim(),
  //             (b?.nama_siswa || "").toString().trim()
  //         )
  //   );
  // }, [getData, searchKeyword, nameCollator]);

  const filteredData = useMemo(() => {
      const q = (searchKeyword || "").trim().toLowerCase();
  
      const base = !q
        ? (getData || [])
        : (getData || []).filter((item) => {
            const name = (item?.nama_siswa || "").toString().toLowerCase();
            const nisn = (item?.nisn || "").toString().toLowerCase();
            return name.includes(q) || nisn.includes(q);
          });
  
      return [...base].sort((a, b) => {
        const orderA =
          a?.order_absen === null || a?.order_absen === undefined || a?.order_absen === ""
            ? null
            : Number(a.order_absen);
  
        const orderB =
          b?.order_absen === null || b?.order_absen === undefined || b?.order_absen === ""
            ? null
            : Number(b.order_absen);
  
        const aIsNew = orderA !== null && !Number.isNaN(orderA);
        const bIsNew = orderB !== null && !Number.isNaN(orderB);
  
        if (!aIsNew && bIsNew) return -1;
        if (aIsNew && !bIsNew) return 1;
  
        if (aIsNew && bIsNew) {
          if (orderA !== orderB) return orderA - orderB;
  
          return nameCollator.compare(
            (a?.nama_siswa || "").toString().trim(),
            (b?.nama_siswa || "").toString().trim()
          );
        }
  
        return nameCollator.compare(
          (a?.nama_siswa || "").toString().trim(),
          (b?.nama_siswa || "").toString().trim()
        );
      });
    }, [getData, searchKeyword, nameCollator]);
      
      
      // =========================
      // FRONTEND PAGINATION
      // =========================
      const totalRows = filteredData.length;
      const totalPages = useMemo(() => {
        const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));
        return pages <= 0 ? 1 : pages;
      }, [totalRows, rowsPerPage]);
      
      useEffect(() => {
        setTablePage(1);
      }, [searchKeyword]);
      
      useEffect(() => {
        setTablePage(1);
      }, [getData]);
      
      useEffect(() => {
        if (tablePage > totalPages) setTablePage(totalPages);
        if (tablePage < 1) setTablePage(1);
      }, [tablePage, totalPages]);
      
      const paginatedData = useMemo(() => {
        const safeRows = Math.max(1, rowsPerPage);
        const start = (tablePage - 1) * safeRows;
        return filteredData.slice(start, start + safeRows);
      }, [filteredData, tablePage, rowsPerPage]);
      
      const pageNumbers = useMemo(() => {
        const maxButtons = 5;
        const pages = [];
        if (totalPages <= maxButtons) {
          for (let i = 1; i <= totalPages; i++) pages.push(i);
          return pages;
        }
      
        const left = Math.max(1, tablePage - 1);
        const right = Math.min(totalPages, tablePage + 1);
      
        pages.push(1);
          if (left > 2) pages.push("...");
          for (let i = left; i <= right; i++) {
            if (i !== 1 && i !== totalPages) pages.push(i);
          }
          if (right < totalPages - 1) pages.push("...");
          pages.push(totalPages);
      
          
          return pages.filter((v, idx, arr) => arr.indexOf(v) === idx);
        }, [tablePage, totalPages]);
      
        const goToPage = (nextPage) => {
          const p = Math.min(Math.max(1, Number(nextPage) || 1), totalPages);
          setTablePage(p);
        };
  
      const toTitleCase = (value) => {
        const s = safeStr(value).toLowerCase().trim();
        if (!s) return "";
        return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
      };
  

    // ========================= UI State =====================
    const [grade, setGrade] = useState("10A");
    // const [q, setQ] = useState("");
  
    // ===== Summary cards (based on selected grade) =====
    const summary = useMemo(() => {
      const base = rows.filter((r) => r.grade === grade);
      const total = base.length;
  
      const selfCompleted = base.filter((r) => r.selfStatus === "Selesai").length;
      const peerCompleted = base.filter((r) => r.peerStatus === "Selesai").length;
  
      const pending = base.filter((r) => r.selfStatus === "Proses" || r.peerStatus === "Proses").length;
  
      return { total, selfCompleted, peerCompleted, pending };
    }, [rows, grade]);

    const summaryCards = useMemo(() => {
      const total = Number(getStatic?.total_siswa ?? 0);
      const self = String(getStatic?.status_self ?? `0/${total}`);
      const peer = String(getStatic?.status_peer ?? `0/${total}`);
      const belum = Number(getStatic?.belum ?? 0);

      return {
        total,
        self,
        peer,
        belum,
      };
    }, [getStatic]);

    // ===== Checkbox selection =====
    const [checkedIds, setCheckedIds] = useState(() => new Set());

    useEffect(() => {
      setCheckedIds((prev) => {
        const validIds = new Set(filteredData.map((r) => getRowId(r)).filter(Boolean));
        const next = new Set([...prev].filter((id) => validIds.has(id)));
        return next;
      });
    }, [filteredData, getRowId]);

    const toggleRowCheck = (row) => {
      const id = getRowId(row);
      if (!id) return;
      setCheckedIds((prev) => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        return next;
      });
    };

    const allCheckedOnPage = useMemo(() => {
      if (!paginatedData.length) return false;
      return paginatedData.every((r) => checkedIds.has(getRowId(r)));
    }, [paginatedData, checkedIds, getRowId]);

    const someCheckedOnPage = useMemo(() => {
      if (!paginatedData.length) return false;
      return paginatedData.some((r) => checkedIds.has(getRowId(r)));
    }, [paginatedData, checkedIds, getRowId]);

    const toggleAllOnPage = () => {
      setCheckedIds((prev) => {
        const next = new Set(prev);
        const shouldCheckAll = !paginatedData.every((r) => next.has(getRowId(r)));

        paginatedData.forEach((r) => {
          const id = getRowId(r);
          if (!id) return;
          if (shouldCheckAll) next.add(id);
          else next.delete(id);
        });

        return next;
      });
    };

    const headerCheckboxRef = useRef(null);

    useEffect(() => {
      if (!headerCheckboxRef.current) return;
      headerCheckboxRef.current.indeterminate = someCheckedOnPage && !allCheckedOnPage;
    }, [someCheckedOnPage, allCheckedOnPage]);


    const reassignSelfChecked = () => {
      if (checkedIds.size === 0) return;

      setGetData((prevRows) => {
        const nextRows = (prevRows || []).map((r) => {
          const id = getRowId(r);
          if (!checkedIds.has(id)) return r;

          return { ...r, status_self: 1 };
        });

        setGetStatic((prevStat) => buildStatisticsFromRows(nextRows, prevStat));
        setCheckedIds(new Set());

        return nextRows;
      });
    };


    const reassignPeersChecked = () => {
      if (checkedIds.size === 0) return;

      setGetData((prevRows) => {
        const nextRows = (prevRows || []).map((r) => {
          const id = getRowId(r);
          if (!checkedIds.has(id)) return r;

          return { ...r, status_peer: 1 };
        });

        setGetStatic((prevStat) => buildStatisticsFromRows(nextRows, prevStat));
        setCheckedIds(new Set());


        return nextRows;
      });
    };

    // ===== STATUS MAPPING =====
    const normalizeStatus = (raw) => {
      const v = String(raw ?? "").trim().toLowerCase();

      if (v === "1" || v === "belum") {
        return { label: "Belum", tone: "danger" };
      }
      if (v === "2" || v === "proses") {
        return { label: "Proses", tone: "primary" };
      }
      if (v === "3" || v === "selesai") {
        return { label: "Selesai", tone: "success" };
      }

      
      return { label: toTitleCase(v || "Belum"), tone: "muted" };
    };

    const StatusPill = ({ value }) => {
      const s = normalizeStatus(value);
      return (
        <span className={`status-pill status-pill--${s.tone}`}>
          <span className="status-pill__dot" />
          {s.label}
        </span>
      );
    };

   return (
    <>
      <style>{css}</style>

      <div className="body">
        <div className="page-header-card">
          <div className="page-header-top d-flex align-items-center flex-wrap">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faGear} />
              </span>
              <h4 className="page-title-text">Konfigurasi Angket</h4>
            </div>

            <div className="ml-auto header-actions">
              <Link to="/konfigurasi-angket-teacher/config-auth-students" className="header-action-link">
                <button className="btn btn-create">
                  <FontAwesomeIcon icon={faGear} />
                  Konfigurasi Passcode
                </button>
              </Link>

              <Link to="/konfigurasi-angket-teacher/config-peers" className="header-action-link">
                <button className="btn btn-create">
                  <FontAwesomeIcon icon={faGear} />
                  Config Rekan Sejawat
                </button>
              </Link>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-teacher">Beranda</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Konfigurasi Angket
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content module-page">
          {/* SUMMARY */}
          <div className="at-cards">
            <Card
              icon={<IconUsers />}
              title="Total Siswa"
              value={summaryCards.total}
              tone="purple"
            />
            <Card
              icon={<IconCheck />}
              title="Menilai Diri"
              value={summaryCards.self}
              tone="green"
            />
            <Card
              icon={<IconUsersMini />}
              title="Menilai Rekan"
              value={summaryCards.peer}
              tone="blue"
            />
            <Card
              icon={<IconClock />}
              title="Belum"
              value={summaryCards.belum}
              tone="red"
            />
          </div>

          {/* FILTER */}
          <div className="module-card filter-card">
            

            {loading ? (
              <div className="filter-skeleton-grid">
                <div className="shimmer shimmer-filter" />
                <div className="shimmer shimmer-filter" />
              </div>
            ) : (
              <div className="filter-grid filter-grid-teacher">
                <div className="filter-field">
                  <label className="filter-label">Semester</label>
                  <select
                    className="filter-control"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_year} (Semester {user?.semester})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="filter-field filter-action-field">
                  <label className="filter-label filter-label-placeholder">Aksi</label>
                  <button
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="btn filter-search-btn"
                  >
                    Cari Data
                  </button>
                </div>
              </div>
            )}
          </div>

          {isFetching && (
            <div className="module-loading">
              <PulseLoader color="#3f5bea" size={10} />
              <span>Memuat data...</span>
            </div>
          )}

          {hasSearched && !isFetching && (
            <div className="angket-result">
              {/* SEARCH */}
              <div className="table-toolbar">
                <div className="search-box">
                  <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
                  <input
                    className="search-input"
                    placeholder="Cari nama siswa atau NISN..."
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>
              </div>

              <div className="angket-table-card">
                <div className="angket-table-scroll">
                <table className="angket-table">
                  <thead>
                    <tr>
                      <th className="col-no">No</th>
                      <th>NISN</th>
                      <th className="text-left">Nama Siswa</th>
                      <th>Passcode Siswa</th>
                      <th>Menilai Diri</th>
                      <th>Menilai Rekan</th>
                      <th className="text-left">Rekan yang Dinilai</th>
                      <th className="text-left">Nama Orang Tua</th>
                      <th>Passcode OTM</th>
                      <th>Penilaian OTM</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredData.length === 0 ? (
                      <tr>
                        <td colSpan={10}>
                          <div className="empty-state">
                            <div className="empty-state-title">Data tidak ditemukan</div>
                            <div className="empty-state-text">
                              Coba ubah kata pencarian atau semester yang digunakan.
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((row, index) => (
                        <tr key={getRowId(row) || index}>
                          <td className="text-center">
                            <span className="angket-number-badge">
                              {(tablePage - 1) * rowsPerPage + index + 1}
                            </span>
                          </td>

                          <td className="text-center">{row.nisn || "-"}</td>
                          <td className="student-name">{toTitleCase(row.nama_siswa) || "-"}</td>
                          <td className="text-center">{row.passcode_siswa || "-"}</td>
                          <td className="text-center">
                            <StatusPill value={row.status_self} />
                          </td>
                          <td className="text-center">
                            <StatusPill value={row.status_peer} />
                          </td>
                          <td>{toTitleCase(row.rekan_yang_dinilai) || "-"}</td>
                          <td>{toTitleCase(row.nama_lengkap_ibu) || "-"}</td>
                          <td className="text-center">{row.passcode_otm || "-"}</td>
                          <td className="text-center">
                            <StatusPill value={row.status_otm} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {filteredData.length > 0 && (
                <div className="module-pagination">
                  <div className="pagination-left">
                    <span className="page-info">
                      Menampilkan{" "}
                      <b>{Math.min((tablePage - 1) * rowsPerPage + 1, totalRows)}</b>
                      {" - "}
                      <b>{Math.min(tablePage * rowsPerPage, totalRows)}</b>
                      {" dari "}
                      <b>{totalRows}</b> data
                    </span>

                    <select
                      className="page-size"
                      value={rowsPerPage}
                      onChange={(e) => {
                        const v = Number(e.target.value) || 10;
                        setRowsPerPage(v);
                        setTablePage(1);
                      }}
                    >
                      <option value={10}>10 / halaman</option>
                      <option value={25}>25 / halaman</option>
                      <option value={50}>50 / halaman</option>
                      <option value={100}>100 / halaman</option>
                    </select>
                  </div>

                  <div className="pagination-right">
                    <button
                      className="page-btn"
                      onClick={() => goToPage(tablePage - 1)}
                      disabled={tablePage <= 1}
                    >
                      Prev
                    </button>

                    <div className="page-numbers">
                      {pageNumbers.map((p, idx) =>
                        p === "..." ? (
                          <span key={`dots-${idx}`} className="page-dots">
                            ...
                          </span>
                        ) : (
                          <button
                            key={`page-${p}`}
                            className={`page-number ${p === tablePage ? "active" : ""}`}
                            onClick={() => goToPage(p)}
                          >
                            {p}
                          </button>
                        )
                      )}
                    </div>

                    <button
                      className="page-btn"
                      onClick={() => goToPage(tablePage + 1)}
                      disabled={tablePage >= totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

/* ===== Small components ===== */
function Card({ icon, title, value, tone }) {
  return (
    <div className="summary-card">
      <div className={`card-ico card-ico--${tone}`}>{icon}</div>
      <div>
        <div className="card-title">{title}</div>
        <div className="card-value">{value}</div>
      </div>
    </div>
  );
}

/* ===== Minimal inline icons ===== */
function IconUsers() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M16 11c1.66 0 3-1.57 3-3.5S17.66 4 16 4s-3 1.57-3 3.5S14.34 11 16 11Z" stroke="currentColor" strokeWidth="2" />
      <path d="M8 11c1.66 0 3-1.57 3-3.5S9.66 4 8 4 5 5.57 5 7.5 6.34 11 8 11Z" stroke="currentColor" strokeWidth="2" />
      <path d="M2 20c0-3 3-5 6-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M22 20c0-3-3-5-6-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 15h8c2.21 0 4 1.79 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconUsersMini() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4Z" stroke="currentColor" strokeWidth="2" />
      <path d="M4 20c0-3.3 3.6-6 8-6s8 2.7 8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M20 6 9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconClock() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10Z" stroke="currentColor" strokeWidth="2" />
      <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/* ===== CSS ===== */
const css = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .module-page{
    padding-top:18px;
    padding-bottom:28px;
  }

  .header-actions{
    display:flex;
    gap:10px;
    align-items:center;
    flex-wrap:wrap;
    justify-content:flex-end;
  }

  .header-action-link{
    text-decoration:none !important;
  }

  .header-actions .btn-create{
    border-radius:10px !important;
    padding:9px 13px !important;
    display:inline-flex;
    align-items:center;
    gap:7px;
    box-shadow:none !important;
    font-size:13px;
    white-space:nowrap;
  }

  .shimmer{
    animation:shimmer 1.2s linear infinite;
    background:linear-gradient(
      to right,
      #e9eef7 8%,
      #f7f9fc 18%,
      #e9eef7 33%
    );
    background-size:800px 104px;
  }

  .filter-skeleton-grid{
    display:grid;
    grid-template-columns:minmax(250px, 420px) 140px;
    gap:13px;
  }

  .shimmer-filter{
    height:68px;
    border-radius:12px;
  }

  /* SUMMARY */
  .at-cards{
    display:grid;
    grid-template-columns:repeat(4, minmax(0, 1fr));
    gap:14px;
    margin-bottom:16px;
  }

  .summary-card{
    background:#fff;
    border:1px solid #e7edf5;
    border-radius:14px;
    padding:15px 16px;
    display:flex;
    gap:12px;
    align-items:center;
    min-height:76px;
    box-shadow:0 1px 2px rgba(15,23,42,.03);
  }

  .card-title{
    font-size:12px;
    color:#64748b;
    margin-bottom:3px;
    font-weight:600;
  }

  .card-value{
    font-size:21px;
    font-weight:800;
    color:#172033;
    line-height:1.15;
  }

  .card-ico{
    width:38px;
    height:38px;
    border-radius:11px;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-shrink:0;
  }

  .card-ico--purple{ background:#eef2ff; color:#4338ca; }
  .card-ico--green{ background:#ecfdf5; color:#047857; }
  .card-ico--blue{ background:#eff6ff; color:#1d4ed8; }
  .card-ico--red{ background:#fff1f2; color:#be123c; }

  /* CARD */
  .module-card{
    background:#fff;
    border:1px solid #e6ebf2;
    border-radius:14px;
    box-shadow:0 1px 2px rgba(15,23,42,.03);
  }

  .filter-card{
    padding:18px;
    margin-bottom:16px;
  }

  .section-heading{
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    gap:12px;
    margin-bottom:15px;
  }

  .section-title{
    margin:0;
    font-size:14px;
    font-weight:800;
    color:#24324a;
  }

  .section-subtitle{
    margin:4px 0 0;
    font-size:12px;
    color:#8490a3;
  }

  /* FILTER */
  .filter-grid{
    display:grid;
    gap:13px;
    align-items:end;
  }

  .filter-grid-teacher{
    grid-template-columns:minmax(250px, 420px) 140px;
  }

  .filter-field{
    min-width:0;
  }

  .filter-label{
    display:block;
    margin-bottom:6px;
    font-size:12px;
    font-weight:700;
    color:#667085;
  }

  .filter-label-placeholder{
    visibility:hidden;
  }

  .filter-control{
    width:100%;
    height:40px;
    border:1px solid #dfe5ee;
    border-radius:10px;
    background:#fff;
    color:#344054;
    padding:0 11px;
    font-size:13px;
    outline:none;
    transition:.15s ease;
  }

  .filter-control:hover{
    border-color:#c7d2e0;
  }

  .filter-control:focus{
    border-color:#7893e8;
    box-shadow:0 0 0 3px rgba(63,91,234,.09);
  }

  .filter-search-btn{
    width:100%;
    height:40px;
    border:0 !important;
    border-radius:10px !important;
    background:#3f5bea !important;
    color:#fff !important;
    font-size:13px !important;
    font-weight:700 !important;
    transition:.15s ease;
  }

  .filter-search-btn:hover:not(:disabled){
    background:#314dcc !important;
  }

  .filter-search-btn:disabled{
    background:#c7cfdd !important;
    cursor:not-allowed;
    opacity:1 !important;
  }

  .module-loading{
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    gap:8px;
    min-height:90px;
    color:#64748b;
    font-size:12px;
  }

  /* TABLE */
  .table-card{
    overflow:hidden;
  }

  .table-toolbar{
    padding:14px 16px;
    border-bottom:1px solid #edf1f5;
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;
  }

  .search-box{
    width:min(430px, 100%);
    position:relative;
  }

  .search-icon{
    position:absolute;
    left:13px;
    top:50%;
    transform:translateY(-50%);
    color:#98a2b3;
    font-size:13px;
    pointer-events:none;
  }

  .search-input{
    width:100%;
    height:40px;
    border:1px solid #dfe5ee;
    border-radius:10px;
    padding:0 12px 0 37px;
    color:#344054;
    font-size:13px;
    outline:none;
    background:#fff;
    transition:.15s ease;
  }

  .search-input::placeholder{
    color:#98a2b3;
  }

  .search-input:focus{
    border-color:#7893e8;
    box-shadow:0 0 0 3px rgba(63,91,234,.08);
  }

  .table-scroll{
    width:100%;
    overflow-x:auto;
    -webkit-overflow-scrolling:touch;
  }

  .module-table{
    width:100%;
    min-width:1120px;
    border-collapse:separate;
    border-spacing:0;
    margin:0;
    font-size:12px;
    color:#344054;
  }

  .module-table thead th{
    background:#f7f9fc;
    color:#667085;
    font-size:11px;
    font-weight:800;
    padding:11px 12px;
    border-bottom:1px solid #e6ebf2;
    text-align:center;
    white-space:nowrap;
    vertical-align:middle;
  }

  .module-table tbody td{
    padding:11px 12px;
    border-bottom:1px solid #eef2f6;
    vertical-align:middle;
    background:#fff;
    line-height:1.45;
  }

  .module-table tbody tr:last-child td{
    border-bottom:0;
  }

  .module-table tbody tr:hover td{
    background:#fbfcfe;
  }

  .module-table .text-left{
    text-align:left;
  }

  .student-name{
    font-weight:700;
    color:#344054;
  }

  .col-no{
    width:56px;
  }

  .number-badge{
    width:28px;
    height:28px;
    border-radius:50%;
    display:inline-flex;
    align-items:center;
    justify-content:center;
    background:#eef2ff;
    color:#3f5bea;
    font-size:11px;
    font-weight:800;
  }

  /* STATUS */
  .status-pill{
    display:inline-flex;
    align-items:center;
    justify-content:center;
    gap:6px;
    padding:5px 10px;
    border-radius:999px;
    font-size:10px;
    font-weight:800;
    line-height:1;
    border:1px solid transparent;
    white-space:nowrap;
  }

  .status-pill__dot{
    width:6px;
    height:6px;
    border-radius:50%;
    display:inline-block;
  }

  .status-pill--success{
    background:#ecfdf3;
    color:#027a48;
    border-color:#d1fadf;
  }
  .status-pill--success .status-pill__dot{ background:#12b76a; }

  .status-pill--primary{
    background:#eff4ff;
    color:#3538cd;
    border-color:#e0e7ff;
  }
  .status-pill--primary .status-pill__dot{ background:#6172f3; }

  .status-pill--danger{
    background:#fff1f3;
    color:#c01048;
    border-color:#ffe4e8;
  }
  .status-pill--danger .status-pill__dot{ background:#f63d68; }

  .status-pill--muted{
    background:#f2f4f7;
    color:#667085;
    border-color:#eaecf0;
  }
  .status-pill--muted .status-pill__dot{ background:#98a2b3; }

  /* EMPTY */
  .empty-state{
    padding:34px 16px;
    text-align:center;
  }

  .empty-state-title{
    font-size:13px;
    font-weight:800;
    color:#475467;
    margin-bottom:4px;
  }

  .empty-state-text{
    font-size:12px;
    color:#98a2b3;
  }

  /* PAGINATION */
  .module-pagination{
    padding:13px 16px;
    border-top:1px solid #edf1f5;
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;
    flex-wrap:wrap;
  }

  .pagination-left,
  .pagination-right{
    display:flex;
    align-items:center;
    gap:8px;
    flex-wrap:wrap;
  }

  .page-info{
    color:#667085;
    font-size:11px;
  }

  .page-size{
    height:34px;
    border:1px solid #dfe5ee;
    border-radius:8px;
    background:#fff;
    padding:0 9px;
    font-size:11px;
    color:#475467;
    outline:none;
  }

  .page-btn,
  .page-number{
    height:32px;
    min-width:32px;
    border:1px solid #dfe5ee;
    background:#fff;
    color:#475467;
    border-radius:8px;
    font-size:11px;
    font-weight:700;
    cursor:pointer;
    transition:.15s ease;
  }

  .page-btn{
    padding:0 10px;
  }

  .page-btn:hover:not(:disabled),
  .page-number:hover:not(.active){
    background:#f8fafc;
    border-color:#cfd8e5;
  }

  .page-btn:disabled{
    opacity:.45;
    cursor:not-allowed;
  }

  .page-numbers{
    display:flex;
    align-items:center;
    gap:5px;
  }

  .page-number.active{
    background:#3f5bea;
    border-color:#3f5bea;
    color:#fff;
  }

  .page-dots{
    padding:0 3px;
    color:#98a2b3;
    font-size:11px;
  }

  @media (max-width:1100px){
    .at-cards{
      grid-template-columns:repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width:780px){
    .module-page{
      padding-top:14px;
    }

    .page-header-top{
      align-items:flex-start !important;
    }

    .header-actions{
      width:100%;
      margin-left:0 !important;
      margin-top:14px;
      justify-content:flex-start;
    }

    .header-actions .header-action-link{
      flex:1 1 180px;
    }

    .header-actions .btn-create{
      width:100%;
      justify-content:center;
    }

    .filter-card{
      padding:15px;
    }

    .filter-grid-teacher,
    .filter-skeleton-grid{
      grid-template-columns:1fr;
    }

    .filter-label-placeholder{
      display:none;
    }

    .search-box{
      width:100%;
    }

    .module-pagination{
      align-items:stretch;
    }

    .pagination-left,
    .pagination-right{
      width:100%;
      justify-content:space-between;
    }
  }

  @media (max-width:560px){
    .at-cards{
      grid-template-columns:1fr;
    }

    .section-subtitle{
      line-height:1.45;
    }

    .pagination-left,
    .pagination-right{
      justify-content:flex-start;
    }

    .page-numbers{
      max-width:100%;
      overflow-x:auto;
    }
  }


/* =========================================================
   FINAL TABLE ANGKET
   Visual mengikuti module-ui / tabel Leger:
   - card radius 16px
   - header #f3f5ff
   - row bersih tanpa border kotak-kotak
   - nomor berbentuk badge
   - pagination menyatu di bawah table card
   ========================================================= */

.angket-result{
  width:100%;
  min-width:0;
}

/* Search/action sengaja berada di luar card tabel seperti module lain */
.angket-result .table-toolbar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  margin-bottom:14px;
  padding:0;
  border:0;
  background:transparent;
}

.angket-table-card{
  width:100%;
  max-width:100%;
  overflow:hidden;
  border:1px solid #e5eaf4;
  border-radius:16px;
  background:#ffffff;
  box-shadow:none;
}

.angket-table-scroll{
  width:100%;
  max-width:100%;
  overflow-x:auto;
  overflow-y:hidden;
  -webkit-overflow-scrolling:touch;
}

.angket-table{
  width:100%;
  min-width:1180px;
  margin:0 !important;
  border-collapse:separate;
  border-spacing:0;
  table-layout:auto;
}

.angket-table th,
.angket-table td{
  vertical-align:middle;
}

.angket-table thead th{
  height:52px;
  padding:13px 16px;
  border:0 !important;
  background:#f3f5ff !important;
  color:#25345f !important;
  font-size:13px;
  font-weight:700;
  text-align:center;
  white-space:nowrap;
}

.angket-table tbody td{
  height:58px;
  padding:13px 16px;
  border:0 !important;
  border-top:1px solid #e9edf5 !important;
  background:#ffffff;
  color:#2b3654;
  font-size:12.7px;
  line-height:1.45;
}

.angket-table tbody tr:first-child td{
  border-top:0 !important;
}

.angket-table tbody tr:hover td{
  background:#fafbff !important;
}

.angket-table .text-left{
  text-align:left !important;
}

.angket-table .text-center{
  text-align:center !important;
}

.angket-table .col-check{
  width:54px;
  text-align:center !important;
}

.angket-table .col-no{
  width:72px;
  text-align:center !important;
}

.angket-table .student-name{
  min-width:190px;
  color:#273553;
  font-size:13px;
  font-weight:600;
  text-align:left !important;
  white-space:normal;
}

.angket-number-badge{
  display:inline-flex;
  width:30px;
  height:30px;
  align-items:center;
  justify-content:center;
  border-radius:999px;
  background:#f1f4ff;
  color:#4362e8;
  font-size:12px;
  font-weight:700;
  box-shadow:inset 0 0 0 1px #e6ebfb;
}

.angket-table .table-checkbox{
  width:16px;
  height:16px;
  margin:0;
  accent-color:#3f5bea;
  cursor:pointer;
  vertical-align:middle;
}

/* Empty state mengikuti shared module UI */
.angket-table .empty-state{
  display:flex;
  min-height:125px;
  align-items:center;
  justify-content:center;
  flex-direction:column;
  gap:4px;
  padding:24px;
  color:#8994ad;
  text-align:center;
}

.angket-table .empty-state-title{
  color:#65718b;
  font-size:13px;
  font-weight:600;
}

.angket-table .empty-state-text{
  color:#98a2b7;
  font-size:12px;
  font-weight:400;
}

/* Pagination dibuat sama dengan module-ui */
.angket-table-card .module-pagination{
  display:flex;
  min-height:70px;
  align-items:center;
  justify-content:space-between;
  gap:16px;
  margin:0;
  padding:14px 22px;
  border-top:1px solid #edf0f5;
  background:#ffffff;
}

.angket-table-card .pagination-left,
.angket-table-card .pagination-right{
  display:flex;
  align-items:center;
  gap:12px;
}

.angket-table-card .page-info{
  color:#64708d;
  font-size:12px;
  white-space:nowrap;
}

.angket-table-card .page-info b{
  color:#2b3758;
  font-weight:700;
}

.angket-table-card .page-size{
  height:42px;
  min-width:160px;
  padding:0 38px 0 14px;
  border:1px solid #dfe5f0;
  border-radius:10px;
  outline:none;
  background:#ffffff;
  color:#2d3856;
  font-size:12.5px;
  font-weight:600;
}

.angket-table-card .page-size:focus{
  border-color:#7892ff;
  box-shadow:0 0 0 3px rgba(63,91,234,.07);
}

.angket-table-card .page-numbers{
  display:flex;
  align-items:center;
  gap:8px;
}

.angket-table-card .page-number,
.angket-table-card .page-btn{
  display:inline-flex;
  height:40px;
  align-items:center;
  justify-content:center;
  border:1px solid #dfe5f0;
  border-radius:10px;
  background:#ffffff;
  color:#64708d;
  font-size:12.5px;
  font-weight:600;
  transition:all .2s ease;
}

.angket-table-card .page-number{
  min-width:40px;
  padding:0 10px;
}

.angket-table-card .page-btn{
  min-width:58px;
  padding:0 12px;
}

.angket-table-card .page-number:hover:not(:disabled),
.angket-table-card .page-btn:hover:not(:disabled){
  border-color:#a9b7f8;
  color:#3f5bea;
}

.angket-table-card .page-number.active{
  border-color:#3f5bea;
  background:#3f5bea;
  color:#ffffff;
  box-shadow:0 5px 12px rgba(63,91,234,.18);
}

.angket-table-card .page-btn:disabled{
  cursor:not-allowed;
  color:#c1c8d7;
  background:#fafbfe;
  opacity:.9;
}

.angket-table-card .page-dots{
  min-width:22px;
  color:#8b95ac;
  font-size:12px;
  text-align:center;
}

@media (max-width:1100px){
  .angket-table thead th,
  .angket-table tbody td{
    padding-right:12px;
    padding-left:12px;
  }
}

@media (max-width:900px){
  .angket-table-card .module-pagination{
    align-items:flex-start;
    flex-direction:column;
  }

  .angket-table-card .pagination-left,
  .angket-table-card .pagination-right{
    width:100%;
    justify-content:space-between;
  }
}

@media (max-width:780px){
  .angket-result .table-toolbar{
    align-items:stretch;
    flex-direction:column;
  }

  .angket-result .search-box,
  .angket-result .reset-btn{
    width:100%;
    max-width:none;
  }

  .angket-table-card{
    border-radius:12px;
  }

  .angket-table{
    min-width:1080px;
  }

  .angket-table-card .module-pagination{
    min-height:0;
    gap:12px;
    padding:13px;
  }

  .angket-table-card .pagination-left,
  .angket-table-card .pagination-right{
    align-items:stretch;
    flex-direction:column;
  }

  .angket-table-card .page-info{
    width:100%;
    text-align:center;
  }

  .angket-table-card .page-size,
  .angket-table-card .page-btn{
    width:100%;
  }

  .angket-table-card .page-numbers{
    justify-content:center;
  }
}


/* =========================================================
   RESPONSIVE TABLE FINAL
   Desktop / laptop / tablet mengikuti lebar container.
   Horizontal scroll HANYA untuk handphone <= 780px.
   ========================================================= */
@media (min-width: 781px) {
  .angket-table-card {
    width: 100% !important;
    max-width: 100% !important;
  }

  .angket-table-scroll {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .angket-table {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    table-layout: fixed !important;
  }

  .angket-table thead th,
  .angket-table tbody td {
    min-width: 0 !important;
    padding: 11px 8px !important;
    white-space: normal !important;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .angket-table thead th {
    font-size: 12px !important;
    line-height: 1.35;
  }

  .angket-table tbody td {
    font-size: 12px !important;
    line-height: 1.45;
  }

  .angket-table .student-name {
    min-width: 0 !important;
    width: auto !important;
    font-size: 12px !important;
  }

  .angket-table .col-no {
    width: auto !important;
  }

  /* 10 kolom teacher: no, nisn, nama, passcode siswa,
     self, peer, rekan, orang tua, passcode OTM, penilaian OTM */
  .angket-table th:nth-child(1),
  .angket-table td:nth-child(1) { width: 5%; }

  .angket-table th:nth-child(2),
  .angket-table td:nth-child(2) { width: 10%; }

  .angket-table th:nth-child(3),
  .angket-table td:nth-child(3) { width: 16%; }

  .angket-table th:nth-child(4),
  .angket-table td:nth-child(4) { width: 10%; }

  .angket-table th:nth-child(5),
  .angket-table td:nth-child(5) { width: 10%; }

  .angket-table th:nth-child(6),
  .angket-table td:nth-child(6) { width: 10%; }

  .angket-table th:nth-child(7),
  .angket-table td:nth-child(7) { width: 13%; }

  .angket-table th:nth-child(8),
  .angket-table td:nth-child(8) { width: 10%; }

  .angket-table th:nth-child(9),
  .angket-table td:nth-child(9) { width: 8%; }

  .angket-table th:nth-child(10),
  .angket-table td:nth-child(10) { width: 8%; }

  .angket-table .status-pill {
    max-width: 100%;
    padding: 5px 8px;
    font-size: 10.5px;
  }

  .angket-number-badge {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }
}

@media (min-width: 781px) and (max-width: 1250px) {
  .angket-table thead th,
  .angket-table tbody td {
    padding-right: 6px !important;
    padding-left: 6px !important;
  }

  .angket-table thead th {
    font-size: 11.5px !important;
  }

  .angket-table tbody td,
  .angket-table .student-name {
    font-size: 11.5px !important;
  }

  .angket-table .status-pill {
    gap: 4px;
    padding: 4px 7px;
    font-size: 10px;
  }

  .angket-table .status-pill__dot {
    width: 6px;
    height: 6px;
  }
}

@media (max-width: 780px) {
  .angket-table-scroll {
    overflow-x: auto !important;
    overflow-y: hidden !important;
  }

  .angket-table {
    width: max-content !important;
    min-width: 1000px !important;
    max-width: none !important;
    table-layout: auto !important;
  }

  .angket-table thead th,
  .angket-table tbody td {
    white-space: nowrap !important;
  }

  .angket-table .student-name {
    min-width: 190px !important;
    white-space: normal !important;
  }
}

`;
